<template>
  <div class="hello-ezuikit-js">
    <div id="video-container"></div>
    <div class="live-opts">
      <div class="opt" @click="playLive">播放/停止</div>
      <div class="opt" @click="toggleAudio">开启/关闭声音</div>
      <div class="opt" @click="fullScreen">全屏</div>
    </div>
  </div>
</template>

<script>
import EZUIKit from "ezuikit-js";
let player = null
export default {
  name: "EZUIKitJs",
  props: {
    autoplay: {
      type: Boolean,
      default: false,
    },
    accessToken: {
      type: String,
      default: ''
    },
    url: {
      type: String,
      default: ''
    },
    mode: {
      // simple - 极简版;standard-标准版;security - 安防版(预览回放);voice-语音版；
      type: String,
      default: 'simple'
    }
  },
  data(){
    return {
      playing: true,
      audio: true,
    }
  },
  mounted(){
    const {autoplay, mode, url, accessToken} = this
    player =  new EZUIKit.EZUIKitPlayer({
      autoplay: autoplay,
      id: "video-container",
      accessToken:"at.2o4abrpr0gq1b79t7dkt7dir5z5han9r-7slrpe66ik-0p00ccg-hngwtdq3c",
      url: "ezopen://open.ys7.com/F00775811/1.hd.live",
      template: mode,
      audio: 1,
      // 视频上方头部控件
      //header: ["capturePicture", "save", "zoom"], // 如果templete参数不为simple,该字段将被覆盖
      //plugin: ['talk'],                       // 加载插件，talk-对讲
      // 视频下方底部控件
      // footer: ["talk", "broadcast", "hd", "fullScreen"], // 如果template参数不为simple,该字段将被覆盖
      // audio: 1, // 是否默认开启声音 0 - 关闭 1 - 开启
      // openSoundCallBack: data => console.log("开启声音回调", data),
      // closeSoundCallBack: data => console.log("关闭声音回调", data),
      // startSaveCallBack: data => console.log("开始录像回调", data),
      // stopSaveCallBack: data => console.log("录像回调", data),
      // capturePictureCallBack: data => console.log("截图成功回调", data),
      // fullScreenCallBack: data => console.log("全屏回调", data),
      // getOSDTimeCallBack: data => console.log("获取OSDTime回调", data),
    });
    console.log("player",player);
    player.reSize()
    // player.init()
    // setTimeout(()=>{
    //   player.stop(); // 方法调用示例，10秒后关闭视频
    // },10000)
  },
  beforeDestroy() {
    player.stop()
  },
  methods:{
    fullScreen(){
      player.fullScreen()
    },
    toggleAudio(){
      if(this.audio){
        this.audio = false
        player.closeSound()
      } else {
        this.audio = true
        player.openSound()
      }
    },
    playLive(){
      if(!this.playing){
        this.playing = true
        player.play()
      } else {
        this.playing = false
        player.stop()
      }
    },
  }
};
</script>
<style>
  .hello-ezuikit-js{
    width:100%;
  }
  .hello-ezuikit-js #video-container{
    width:100%;
  }
  .live-opts{
    display: flex;
    justify-content: flex-start;
    align-items: center;
    padding-left: .3rem;
    padding-right: .3rem;
    margin-top: .4rem;
  }
  .live-opts .opt{
    color: #333;
    border: 1px solid #eee;
    border-radius: 4px;
    padding: 4px 10px;
  }
  .live-opts .opt+.opt{
    margin-left: .3rem;
  }
</style>